import React, { useState, useRef, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { colorIndex, colors } from "../configs";
import { useSelector } from "react-redux";
import { createLabel, formatCurrency, handleDigit, summary } from "../Utility/function";
import { normalSort } from "../Utility/sort";
import { stringFullDate, translateClock } from "../Utility/dateTime";
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';
import { Button } from 'rsuite';

import '../styles/CartScreen.css'
import { ChartScreen, TimeControl } from "../components";

const { dark, white, lightGray, one, backgroundColor } = colors;

const topSaleOptions = [
    { id:1, name:'หมวดหมู่ขายดี' },
    { id:2, name:'สินค้าขายดี' },
];

const TopsaleRender = ({ display }) =>{
    return <div style={{minHeight:'400px'}} >
        {display.map((item,index) =>{
            let backgroundColor = colorIndex[index]||dark
            const { name, qty, net } = item;
            return(
                <Row key={index}  >
                <Col xs='6'  style={styles.container10} >
                    <div style={{minWidth:30,height:30,borderRadius:10,display:'flex',justifyContent:'center',alignItems:'center',marginRight:8,color:white,backgroundColor}} >
                    {index+1}
                    </div>
                    <div style={styles.container11} >
                    {name}
                    </div>
                </Col>
                <Col xs='3' style={styles.container12} >
                    {qty}
                </Col>
                <Col xs='3' style={styles.container12} >
                    {handleDigit(net)}
                </Col>
                </Row>
            )
        })}
    </div>
}

function DashboardScreen() {
  const { t } = useTranslation();
  const { shop : { cutOff = new Date(), smartCategory } } = useSelector((state)=> state.shop);
  const { selectedBill, selectedVoidedBill, startDate, endDate } = useSelector((state)=> state.bill)
  const [option, setOption] = useState(1)


  function manageData(bills){

    const productWithHour = bills.flatMap(item => 
        item.product.map(({ id, name, qty, totalPrice, net}) => ({
            id,
            name,
            qty,
            totalPrice,
            net,
            hour: new Date(item.dateTime).getHours().toString(),
            hourName:translateClock(new Date(item.dateTime).getHours().toString(),t('clock'))
        }))
    );
    let secondProduct = []

    for(const item of productWithHour){
        let thisProduct = secondProduct.find(a=>a.hour===item.hour && a.id===item.id)
        if(thisProduct && thisProduct.id){
            thisProduct.net += item.net
            thisProduct.qty += item.qty
        } else {
            secondProduct.push(item)
        }
    };

    let sortProduct = normalSort('totalPrice',secondProduct)
    let finalProduct = []
    let datasets = [] // ยอดขายรายชั่วโมง
      let labels = createLabel(new Date(cutOff).getHours())
      for (const item of labels) {
        let arr = selectedBill.filter((a)=>{return(new Date(a.dateTime).getHours()==item)})
        datasets.push({name:translateClock(item,t('clock')),ยอดขายรายชั่วโมง:parseFloat(summary(arr, 'moneyMustPaid').toFixed(2))})
        finalProduct.push(...sortProduct.filter(a=>a.hour===item))
    };

    return { datasets, finalProduct, bar:'ยอดขายรายชั่วโมง' }
}

  const { datasets, bar, totalSale, totalDiscount, totalCost, billQty,
    profit, averageSale, averageProfile, cancelBillQty, cancelSale, products, categorys
   } = useMemo(()=>{
    const { datasets, bar } = manageData(selectedBill);
    const firstLevel = new Map((smartCategory.find(a=>a.level === 1)?.value || []).map(category => [category.id, category.name]));
    
    let totalSale = 0; // ยอดใช้จ่ายต่อบิล
    let totalDiscount = 0
    let totalCost = 0
    let products = [];
    let categorys = [];
    const billQty = selectedBill.length
    selectedBill.forEach(item=>{
        const { moneyMustPaid, campaign = [], manualDiscount = 0, pointDiscount , productDiscount = 0, product = []  } = item;
        totalSale += moneyMustPaid
        totalDiscount += summary(campaign, 'discount') + Number(manualDiscount) + Number(pointDiscount.value) + Number(productDiscount)
        product.forEach(a=>{
            const { id, name, category = [], net, totalCost:cost, qty } = a;
            totalCost += Number(cost)
            let findProduct = products.find(b=>b.id === id)
            if(findProduct){
                findProduct.net += net
                findProduct.qty += qty
            } else {
                products.push({ id, name, net, qty })
            }
            if(category.length>0){
                let findCategory = categorys.find(a=>a.id===category[0])
                if(findCategory){
                    findCategory.net += net
                    findCategory.qty += qty
                } else {
                    categorys.push({ id:category[0], qty, net, name:firstLevel.get(category[0]) || 'ไม่พบหมวดหมู่' })
                }
            } else {
              let checkCategory = categorys.find(a=>a.id ==='x')
              if(checkCategory){
                  checkCategory.qty += qty
                  checkCategory.net += net
              } else {
                  categorys.push({ id:'x', qty, net,name:'ไม่มีหมวดหมู่'})
              }
          }
        })
    })
    const profit = handleDigit(totalSale - totalCost);
    const averageSale = billQty>0?handleDigit(totalSale/billQty):0;
    const averageProfile = billQty>0?handleDigit((totalSale - totalCost)*100/totalSale):0;
    const cancelBillQty = selectedVoidedBill.length;
    const cancelSale = summary(selectedVoidedBill,'moneyMustPaid')

    return { 
        datasets, 
        bar, 
        totalSale:handleDigit(totalSale),
        totalDiscount:handleDigit(totalDiscount),
        totalCost:handleDigit(totalCost),
        billQty,
        profit,
        averageSale,
        averageProfile,
        cancelBillQty,
        cancelSale:handleDigit(cancelSale),
        products:normalSort('net',products.slice(0,10)),
        categorys:normalSort('net',categorys.slice(0,10))
    }
  },[selectedBill, selectedVoidedBill]);



  const displayRef = useRef(null);

  const handleCapture = () => {
    if (displayRef.current) {
      html2canvas(displayRef.current,{
        scrollX: -window.scrollX, // Capture full horizontal scroll
      windowWidth: displayRef.current.scrollWidth, // Set to the full scrollable width
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const link = document.createElement('a');
          link.href = imgData;
          link.download = `ยอดขายรายชั่วโมง ${stringFullDate(startDate)} - ${stringFullDate(endDate)}.png`;
          link.click();
        });
    }
  };

  return (
    <div  >
        <div style={{position:'sticky', top:0, backgroundColor, zIndex:9 }} >
            <h1>ภาพรวมธุรกิจ</h1>
            <TimeControl/>
        </div>
      <Row ref={displayRef}  style={styles.container} >
          <Col  lg={12}  >
            <div style={styles.container2} >
                <div style={styles.container3} >
                  <h4>ยอดขายสุทธิ : <b>{formatCurrency(summary(selectedBill,'moneyMustPaid'))}</b> {t('currency')} </h4>
                  <Button onClick={handleCapture} color='red' appearance="ghost" >
                        บันทึกกราฟ
                  </Button>
                </div>
                <ChartScreen chart={datasets} bar={bar} name={t('ranking.time')} content={t('ranking.sale')} />
            </div>
          </Col>
      </Row>
      <Row style={styles.container4}>
            <Col md='12' lg='12' style={styles.container5} >
                <div style={styles.container6}>
                    <h5><b>สรุป</b></h5>
                    <Row>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="red" appearance="primary" >
                            ยอดขาย
                            <h6>{totalSale}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="orange" appearance="primary" >
                            กำไร
                            <h6>{profit}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="yellow" appearance="primary" >
                            ต้นทุน
                            <h6>{totalCost}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="green" appearance="primary" >
                            ส่วนลด
                            <h6>{totalDiscount}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="cyan" appearance="primary" >
                            จำนวนใบเสร็จ
                            <h6>{billQty}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="blue" appearance="primary" >
                            ยอดขายเฉลี่ยต่อใบเสร็จ
                            <h6>{averageSale}</h6>
                          </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} color="violet" appearance="primary" >
                            อัตรากำไร
                            <h6>{averageProfile}</h6>
                            </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} >
                            จำนวนใบเสร็จที่ยกเลิก
                            <h6>{cancelBillQty}</h6>
                            </Button>
                        </Col>
                        <Col xs='12' sm='6' md='4' style={styles.container7} >
                          <Button style={styles.container8} >
                          มูลค่าที่ยกเลิก
                            <h6>{cancelSale}</h6>
                          </Button>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
        <Row style={styles.container4}>
            <Col md='12' lg='12' style={styles.container5} >
                <div style={styles.container6}>
                    <h5><b>{t('ranking.rank')}</b></h5>
                    <Row>
                        {topSaleOptions.map((item)=>{
                            const { id, name } = item;
                            return(
                                <Col key={id} xs='6' onClick={()=>{setOption(id)}} style={{cursor:'pointer'}} >
                                    <div style={{marginLeft:5,marginRight:5,borderBottom:`${id===option?'2px':'0px'} solid ${one}`,paddingBottom:5,display:'flex',justifyContent:'center'}} >
                                        {id===option
                                            ?<h6 style={{color:one}} ><b>{name}</b></h6>
                                            :<h6>{name}</h6>
                                        }
                                    </div>
                                </Col>
                            )
                        })}
                        <Row style={styles.container9} >
                            <Col xs='6' >{t('ranking.name')}</Col>
                            <Col xs='3' >{t('ranking.amount')}</Col>
                            <Col xs='3' >{t('ranking.sale')}</Col>
                        </Row>
                        {option===2
                            ?<TopsaleRender display={products} />
                            :<TopsaleRender display={categorys} />
                        }
                    </Row>
                </div>
            </Col>
        </Row>
    </div>
  );
};

const styles = {
    container : {
      backgroundColor:white,borderRadius:20,marginLeft:0,marginRight:0,marginBottom:20
    },
    container2 : {
      backgroundColor:white,margin:5,padding:10,borderRadius:20,height:'400px',marginRight:0,overflowX:'auto'
    },
    container3 : {
      display:'flex',justifyContent:'space-between',alignItems:'center'
    },
    container4 : {
      borderRadius: 20, marginLeft: 20, marginRight: 20,padding:0
    },
    container5 : {
      padding:0,paddingRight:5
    },
    container6 : {
      border: `1px solid ${lightGray}`, borderRadius: 20, padding: 10,backgroundColor:white,  marginBottom:20
    },
    container7 : {
      marginBottom:'1rem'
    },
    container8 : {
      width:'100%',display:'flex',flexDirection:'column'
    },
    container9 : {
      paddingTop:20,paddingBottom:10
    },
    container10 : {
      display:'flex',flexDirection:'row',alignItems:'center',paddingTop:3,paddingBottom:3
    },
    container11 : {
      whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%'
    },
    container12 : {
      display:'flex',alignItems:'flex-end',paddingRight:5
    }
}

export default DashboardScreen;
